angular.module("cineplexAppConstants", [])
.constant("cineplexConstants", {
    smBreakpoint: 768,
    mdBreakpoint: 992,
    lgBreakpoint: 1082
});